import React, {Component, PropTypes} from 'react'
import {Grid} from 'react-bootstrap'
import style from './AppFooter.less'
import config from '../../config'

class AppFooter extends Component {
    static propTypes = {
    }

    render() {

        return (
            <div className={style.default}>
                <Grid>
                    <div className={style.side}>
                        {config.whiteMark.cguLink && <a href={config.whiteMark.cguLink}>CGU</a>}
                    </div>
                    <div className={style.container}>
                        <img height={40} src={config.whiteMark.bottomLogo} />
                    </div>
                </Grid>                
            </div>
        )
    }
}

export default AppFooter


// WEBPACK FOOTER //
// ./lib/app/components/AppFooter.js